import routes from './routes';

const config: any = {
  routes,
};

export default config;
